module.exports = __webpack_public_path__ + "static/material-pearl.9d711ae9.svg";